import { Howl } from 'howler';
import abcSrc from '../sound/abc.mp3';

const lettersSprite = {
  a: [0.74, 0.51],
  b: [1.98, 0.49],
  c: [3.25, 1.59],
  d: [4.84, 0.47],
  e: [6.32, 0.54],
  f: [7.84, 0.57],
  g: [9.35, 0.57],
  h: [10.9, 0.66],
  i: [12.35, 0.62],
  j: [14, 0.5],
  k: [15.01, 0.71],
  l: [16.6, 0.56],
  m: [17.84, 0.55],
  n: [19.08, 0.52],
  o: [20.45, 0.48],
  p: [21.8, 0.48],
  q: [23.06, 0.57],
  r: [24.27, 0.56],
  s: [25.53, 0.66],
  t: [26.87, 0.55],
  u: [28.03, 1.52],
  v: [29.25, 0.6],
  w: [30.42, 0.76],
  x: [31.65, 0.8],
  y: [33.04, 0.59],
  z: [34.18, 0.55],
};

Object.values(lettersSprite).forEach((sound) => {
  // convert seconds to milliseconds
  sound[0] *= 1000;
  sound[1] *= 1000;
});

const letterSounds = new Howl({
  src: [abcSrc],
  sprite: lettersSprite,
});

export default letterSounds;



// WEBPACK FOOTER //
// ./src/js/letter-sounds.js